import React from 'react';
import { get } from 'lodash'
import moment from 'moment'
import { HourglassTop, StarFill, XCircle, ChatLeftDots } from 'react-bootstrap-icons';



export const StudentReflectionStatusIndicator = ({
    userReflection = {}
}) => {
    const isWaitingForStartDate = moment().isBefore(userReflection.startDate, 'day');
    const content = get(userReflection, 'content');
    const hasMissedEndDate = moment().isAfter(userReflection.endDate, 'day');
    if (isWaitingForStartDate) {
        return (<HourglassTop />);
    }

    if (hasMissedEndDate) {
        return content ? (<StarFill />) : (<XCircle />);
    }

    return content ? (<StarFill />)  : (<ChatLeftDots />);
};
